import { call, put, takeLatest } from 'redux-saga/effects';

import { Order } from '@models/Order';
import { OrderApi } from '@apis/OrderApi';
import { HealthClaim } from '@models/HealthClaim';
import { HealthClaimApi } from '@apis/HealthClaimApi';
import { SagaPayload } from '@utils/typescript';
import { history } from '@utils/history';

import {
  policyFetch,
  PolicyFetchPayload,
  healthClaimCreate,
  HealthClaimCreatePayload,
  stateUpdate,
  StateUpdatePayload,
} from './action';

function* handlePolicyFetch({ payload }: SagaPayload<PolicyFetchPayload>) {
  const state: StateUpdatePayload = { policy: null };
  try {
    state.policy = (yield call(OrderApi.get, payload)) as Order;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

function* handleHealthClaimCreate({ payload }: SagaPayload<HealthClaimCreatePayload>) {
  const state: StateUpdatePayload = { healthClaim: null };
  try {
    state.healthClaim = (yield call(HealthClaimApi.create, payload)) as HealthClaim;
    yield put(stateUpdate(state));
    history.navigate(`/user-dashboard/claim/HealthClaim/${state.healthClaim.id}`, {
      replace: true,
    });
  } catch {
    yield put(stateUpdate(state));
  }
}

export default function* () {
  yield takeLatest(policyFetch, handlePolicyFetch);
  yield takeLatest(healthClaimCreate, handleHealthClaimCreate);
}
